import { string, bool, shape, number, arrayOf, oneOfType } from 'prop-types';

const selectOptionPropTypes = shape({
  value: oneOfType([number, string, bool]),
  label: string,
  code: string,
});

const preventiveTaskBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  description: string,

  actionType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  active: oneOfType([bool, number, selectOptionPropTypes]),

  priority: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  deviation: number,

  repeatType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  repeatInterval: number.isRequired,
};

const preventiveTaskBasicInformationDefaultProps = {
  description: null,
  active: true,
  deviation: null,
};

const preventiveTaskWeekdayPropTypes = {
  id: number,
  preventiveTaskId: number,
  weekday: oneOfType([number, selectOptionPropTypes]).isRequired,
};

const preventiveTaskWeekdayDefaultProps = {
  id: null,
  preventiveTaskId: null,
};

const preventiveTaskMonthlyDayPropTypes = {
  id: number,
  preventiveTaskId: number,
  dayOfMonth: number,
  isLastDayOfMonth: bool,
};

const preventiveTaskMonthlyDayDefaultProps = {
  id: null,
  preventiveTaskId: null,
  dayOfMonth: null,
  isLastDayOfMonth: false,
};

const preventiveTaskMonthlyRulePropTypes = {
  id: number,
  preventiveTaskId: number,

  monthlyType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  weekOrder: oneOfType([number, selectOptionPropTypes]),

  weekday: oneOfType([number, selectOptionPropTypes]).isRequired,
};

const preventiveTaskMonthlyRuleDefaultProps = {
  id: null,
  preventiveTaskId: null,
  weekOrder: null,
};

const preventiveTaskChecklistItemPropTypes = {
  id: number,
  preventiveTaskId: number,
  name: string.isRequired,
  description: string,
};

const preventiveTaskChecklistItemDefaultProps = {
  id: null,
  preventiveTaskId: null,
  description: null,
};

const preventiveTaskFullInformationPropTypes = {
  ...preventiveTaskBasicInformationPropTypes,

  weekdays: arrayOf(shape(preventiveTaskWeekdayPropTypes)),

  monthlyDays: arrayOf(shape(preventiveTaskMonthlyDayPropTypes)),

  monthlyRules: arrayOf(shape(preventiveTaskMonthlyRulePropTypes)),

  checklistItems: arrayOf(shape(preventiveTaskChecklistItemPropTypes)),
};

const preventiveTaskFullInformationDefaultProps = {
  ...preventiveTaskBasicInformationDefaultProps,
  weekdays: [],
  monthlyDays: [],
  monthlyRules: [],
  checklistItems: [],
};

const preventiveTaskFormPropTypes = {
  name: string,
  description: string,

  actionType: oneOfType([number, string, selectOptionPropTypes]),

  active: oneOfType([bool, number, selectOptionPropTypes]),

  priority: oneOfType([number, string, selectOptionPropTypes]),

  deviation: oneOfType([number, string]),

  repeatType: oneOfType([number, string, selectOptionPropTypes]),

  repeatInterval: oneOfType([number, string]),

  weekdays: arrayOf(
    shape({
      weekday: oneOfType([number, string, selectOptionPropTypes]),
    }),
  ),

  monthlyDays: arrayOf(
    shape({
      dayOfMonth: oneOfType([number, string]),
      isLastDayOfMonth: bool,
    }),
  ),

  monthlyRules: arrayOf(
    shape({
      monthlyType: oneOfType([number, string, selectOptionPropTypes]),
      weekOrder: oneOfType([number, string, selectOptionPropTypes]),
      weekday: oneOfType([number, string, selectOptionPropTypes]),
    }),
  ),

  checklistItems: arrayOf(
    shape({
      name: string,
      description: string,
    }),
  ),
};

const preventiveTaskFormDefaultProps = {
  name: '',
  description: null,
  actionType: null,
  active: true,
  priority: null,
  deviation: null,
  repeatType: null,
  repeatInterval: 1,
  weekdays: [],
  monthlyDays: [],
  monthlyRules: [],
  checklistItems: [],
};

export {
  selectOptionPropTypes,
  preventiveTaskBasicInformationPropTypes,
  preventiveTaskBasicInformationDefaultProps,
  preventiveTaskWeekdayPropTypes,
  preventiveTaskWeekdayDefaultProps,
  preventiveTaskMonthlyDayPropTypes,
  preventiveTaskMonthlyDayDefaultProps,
  preventiveTaskMonthlyRulePropTypes,
  preventiveTaskMonthlyRuleDefaultProps,
  preventiveTaskChecklistItemPropTypes,
  preventiveTaskChecklistItemDefaultProps,
  preventiveTaskFullInformationPropTypes,
  preventiveTaskFullInformationDefaultProps,
  preventiveTaskFormPropTypes,
  preventiveTaskFormDefaultProps,
};
